import React from 'react';

const linkProps = {
    target: '_blank',
    rel: 'noreferrer',
    className: 'text-decoration-underline fw-bold',
};

export function OptInConsentMsg({ cta }) {
    return (
        <small className="lh-base">
            By clicking {cta}, I agree to the{' '}
            <a href="https://milanlaser.com/privacy" {...linkProps}>
                Privacy Policy
            </a>
            ,{' '}
            <a href="https://milanlaser.com/terms" {...linkProps}>
                Mobile Terms
            </a>
            , and{' '}
            <a href="https://milanlaser.com/terms" {...linkProps}>
                Terms of Service
            </a>{' '}
            and consent to recurring promotional and service-related calls, emails, and texts from Milan Laser
            (including short code 64526, AI or automated texts). Consent to contact is not a purchase condition.
            Frequency varies. Msg&amp;data rates may apply. STOP to end. HELP for help.{' '}
            <a href="tel:+18336672967" className="text-decoration-underline fw-bold text-nowrap">
                1-833-667-2967
            </a>{' '}
            or email{' '}
            <a href="mailto:privacy@milanlaser.com" className="text-decoration-underline fw-bold">
                privacy@milanlaser.com
            </a>{' '}
            for support.
        </small>
    );
}

export default OptInConsentMsg;
